import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
// import 'material-design-icons-iconfont/dist/material-design-icons.css'
// import '@mdi/font/css/materialdesignicons.css';

require('./scss/style.scss')

// vue-router と routes.js をインポート
import VueRouter from 'vue-router';
import {
  routes
} from './routes';

// VueRouterをプラグインとして指定
Vue.use(VueRouter);

// VueRouterインスタンスを作成
const router = new VueRouter({
  mode: 'history',
  routes
});

new Vue({
  el: '#app',
  router, // VueインスンタンスにVueRouterインスンタンスを渡す
  vuetify,
  render: h => h(App)
});

// テスト環境アップロード
// firebase deploy
// 本番環境アップロード
// firebase deploy --project prod